import { CircularProgress } from "@mui/material";
import { FC } from "react";
import { LoaderWrapper } from "./styles";

const Loader: FC = () => {
  return (
    <LoaderWrapper>
      <CircularProgress />
    </LoaderWrapper>
  );
};

export default Loader;
